import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Chip,
} from '@mui/material';

export function RecurringTaskUpdateDialog({ open, onClose, onUpdateChoice }) {
  const choices = [
    { 
      key: 'instance', 
      label: 'Update this instance only', 
      description: 'Only update this specific occurrence'
    },
    { 
      key: 'future', 
      label: 'Update all future tasks', 
      description: 'Update this and all future occurrences'
    },
    { 
      key: 'all', 
      label: 'Update all tasks', 
      description: 'Update all occurrences including past ones'
    }
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          This is a recurrent task.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          How would you like to update this recurring task?
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          {choices.map((choice) => (
            <Chip
              key={choice.key}
              label={choice.label}
              variant="outlined"
              onClick={() => onUpdateChoice(choice.key)}
              sx={{ 
                justifyContent: 'flex-start',
                p: 2,
                '&:hover': {
                  backgroundColor: 'action.hover',
                  cursor: 'pointer'
                }
              }}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
